import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import { useSelector } from 'react-redux'
import { HELPER, CONSTANTS } from '../../utils'

import Paper from '@material-ui/core/Paper'
import Zoom from '@material-ui/core/Zoom'

const useCustomAlerts = () => {
	const { message, type, group } = useSelector((state) => state.toast)

	if (!HELPER.isEmpty(message) && !HELPER.isEmpty(type)) {
		return group === CONSTANTS.ERROR_TYPE.ALERT ? (
			<div className={'col mx-auto col-xs-12 col-sm-12 col-md-12 col-lg-12 alert_classes'}>
				<Zoom in={true}>
					<Paper elevation={4}>
						<div className={`alert alert-${type}`} role="alert">
							{ReactHtmlParser(message)}
						</div>
					</Paper>
				</Zoom>
			</div>
		) : (
			<></>
		)
	}
	return <></>
}

export default useCustomAlerts
